<mat-form-field class="width-100">
  <mat-label>{{label | translate}}</mat-label>
  <input matInput #input class="input" [disabled]="mode!=Mode.edition" [max]="max" [min]="min" [required]="required"
    type="number" [value]="value" (input)="valueChange.next(input.value)">
  <mat-error *ngIf="required">{{'Mandatory field' | translate}}</mat-error>
  <mat-hint  *ngIf="hint">{{hint | translate}}</mat-hint>
</mat-form-field>
